import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'invoiceable',
})
export class InvoiceablePipe implements PipeTransform {

  private key = '';

  /**
   * @param value The class name of the invoiceable entity
   */
  transform(value: string): string {
    this.key = '';
    switch (value) {
      case 'StandaloneServiceBooking':
        this.key = 'SERVICEBOOKING.SINGULAR';
        break;
      case 'RoomBooking':
        this.key = 'ROOMBOOKING.SINGULAR';
        break;
      case 'InternalRegistration' || 'ExternalRegistration':
        this.key = 'PRESENTIAL.PARTICIPATION';
        break;
      default :
        this.key = 'INVOICES.ERRORS.SINGULAR';
        break;
    }
    return this.key;
  }
}

